export default __webpack_public_path__ + "0ec69a13218f29f6df9071bbec2ba143.svg";